function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.757135 2.11819C0.757135 1.40803 1.33283 0.83233 2.04299 0.83233H17.2895C18.7099 0.83233 19.8613 1.98372 19.8613 3.40404V16.0789C19.8613 16.3832 19.6145 16.63 19.3102 16.63H2.04299C1.33283 16.63 0.757135 16.0543 0.757135 15.3441V2.11819Z",
  stroke: "white",
  strokeWidth: 1.10216
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-10",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5547 4.50587C16.5547 3.99861 16.9659 3.5874 17.4732 3.5874H21.2389C23.8259 3.5874 25.9231 5.68458 25.9231 8.27158V16.6296C25.9231 16.934 25.6763 17.1807 25.372 17.1807H17.1058C16.8014 17.1807 16.5547 16.934 16.5547 16.6296V4.50587Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5547 4.50587C16.5547 3.99861 16.9659 3.5874 17.4732 3.5874H21.2389C23.8259 3.5874 25.9231 5.68458 25.9231 8.27158V16.6296C25.9231 16.934 25.6763 17.1807 25.372 17.1807H17.1058C16.8014 17.1807 16.5547 16.934 16.5547 16.6296V4.50587Z",
  fill: "#373D49",
  stroke: "white",
  strokeWidth: 2.20432,
  mask: "url(#path-2-inside-10)"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-20",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 19.1265,
  y: 7.07788,
  width: 6.79666,
  height: 4.04126,
  rx: 0.734774
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 19.1265,
  y: 7.07788,
  width: 6.79666,
  height: 4.04126,
  rx: 0.734774,
  stroke: "white",
  strokeWidth: 2.20432,
  mask: "url(#path-3-inside-20)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.63518,
  cy: 16.8133,
  r: 2.02063,
  fill: "#373D49",
  stroke: "white",
  strokeWidth: 1.10216
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.4118,
  cy: 16.8133,
  r: 2.02063,
  fill: "#373D49",
  stroke: "white",
  strokeWidth: 1.10216
});

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.635eca31.svg";
export { ForwardRef as ReactComponent };